<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-04-28 10:31:43
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-05-08 17:48:42
 * @FilePath: \seller.sviptrader.com\src\views\configure\rulesManage\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding rules-manage" style="height: 100%">
		<Panel style="min-height: 100%" :contentPaddingTop="12">
			<el-tabs v-model="activeMain">
				<el-tab-pane :label="item.name" :name="item.value" v-for="item in tabListMain" :key="item.value"></el-tab-pane>
			</el-tabs>
			<GoodsRule v-if="activeMain === '0'"></GoodsRule>
			<SampleRule v-if="activeMain === '1'"></SampleRule>
			<DrRule v-if="activeMain === '2'"></DrRule>
			<CooprationRule v-if="activeMain === '3'"></CooprationRule>
			<DeliveryRule v-if="activeMain === '4'"></DeliveryRule>
		</Panel>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import GoodsRule from './components/goodsRule.vue';
import SampleRule from './components/sampleRule.vue';
import DrRule from './components/drRule/list/index.vue';
import CooprationRule from './components/cooprationRule.vue';
import DeliveryRule from './components/deliveryRule.vue';
export default {
	name: 'rulesManageList',
	components: {
		SampleRule,
		GoodsRule,
		DrRule,
		CooprationRule,
		DeliveryRule,
	},
	computed: {
		...mapGetters(['canShowPlatformList']),
		// 只有抖音,快手才支持商品规则
		showGoodsRule() {
			const platList = [dataMap.PLATFORM_DY.value, dataMap.PLATFORM_KS.value];
			return this.canShowPlatformList.some(item => platList.includes(`${item.value}`));
		},
		tabListMain() {
			let goods = {
				name: '商品规则',
				value: '0',
				isShow: this.$auth.hasPermi('system:shop:rule-administration') && this.showGoodsRule,
			};
			// 样品
			let sample = {
				name: '样品规则',
				value: '1',
				isShow: this.$auth.hasPermi('system:sample:rule-administration'),
			};
			// 样品
			let talent = {
				name: '达人规则',
				value: '2',
				isShow: this.$auth.hasPermi('setting:ruleManage:drRule'),
			};
			// 星选协作
			let cooperation = {
				name: '星选协作',
				value: '3',
				isShow: this.$auth.hasPermi('system:coopration:rule-administration'),
			};
			// 支付规则
			let delivery = {
				name: '交付规则',
				value: '4',
				isShow: this.$auth.hasPermi('system:delivery:rule-administration'),
			};
			return [goods, sample, talent, cooperation, delivery].filter(item => item.isShow);
		},
	},
	data() {
		return {
			activeMain: '',
		};
	},
	created() {
		this.activeMain = this.$route.query.type || this.tabListMain?.find(item => item.isShow).value;
	},
};
</script>
<style lang="less" scoped>
.rules-manage {
	/deep/ .el-table .el-table__cell {
		vertical-align: top;
	}
	/deep/ .el-table::before {
		height: 0px;
	}
}
</style>
